import { render, staticRenderFns } from "./ArchivePayments.vue?vue&type=template&id=7b09d25b&scoped=true"
import script from "./ArchivePayments.vue?vue&type=script&lang=js"
export * from "./ArchivePayments.vue?vue&type=script&lang=js"
import style0 from "./ArchivePayments.vue?vue&type=style&index=0&id=7b09d25b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b09d25b",
  null
  
)

export default component.exports